import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { Estatus } from '@p-p-portafolio/interfaces/estatus';
import { EstatusService } from '@p-p-portafolio/services/estatus.service';
import { SwalService } from '@shared/utils/swal.service';
import { EstatusFormComponent } from './estatus-form/estatus-form.component';
import Swal from 'sweetalert2';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-estatus',
  templateUrl: './estatus.component.html',
  styleUrls: ['./estatus.component.css']
})
export class EstatusComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayedColumns: Column[] = [
    { field: 'sEmpresa', header: 'Empresa' },
    { field: 'codigoEstado', header: 'Código Estado' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'actions', header: 'Acciones' }
  ];

  private readonly _width: string = '1000px';
  public loading: boolean = true;
  public dataSource: Estatus[] = [];

  constructor(
    public dialog: MatDialog,
    private estatusService: EstatusService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.estatusService.read().subscribe({
      next: (response) => {
        if (response.data) {
          this.dataSource = response.data;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar estatus:', err);
        this.swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  openCreate() {
    const dialogRef = this.dialog.open(EstatusFormComponent, {
      width: this._width
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.read();
      }
    });
  }

  openUpdate(model: Estatus) {
    const dialogRef = this.dialog.open(EstatusFormComponent, {
      width: this._width,
      data: model
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.read();
      }
    });
  }

  delete(model: Estatus) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el estatus ${model.codigoEstado}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.estatusService.delete(model).subscribe({
          next: (response) => {
            if (response.exito === 1) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error('No se pudo eliminar');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
